import axios, { InternalAxiosRequestConfig } from 'axios';
import { authStore } from '../store/authStore/authStore';

export const baseService = axios.create({
  withCredentials: true,
  baseURL: process.env.NEXT_PUBLIC_BACK_PROD,
});


baseService.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = sessionStorage.getItem("accessToken");
    if (token) {
      config.headers.set("Authorization", `Bearer ${token}`);
    }
    return config;
  },
  (error) => Promise.reject(error)
);


baseService.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const refreshToken = sessionStorage.getItem("refreshToken");

      if (refreshToken) {
        try {
          const tokens = await authStore.async.fetchRefreshToken(refreshToken);
          sessionStorage.setItem("accessToken", tokens.access_token);
          sessionStorage.setItem("refreshToken", tokens.refresh_token);

          originalRequest.headers["Authorization"] = `Bearer ${tokens.access_token}`;
          return baseService(originalRequest); 
        } catch (e) {
          await authStore.async.redirectToKeycloak(window.location.origin);
        }
      }
    }

    return Promise.reject(error);
  }
);
